import FaqContact from "app/pages/Faq/FaqFooter/FaqContact/FaqContact";
import { useSelector, shallowEqual } from "react-redux";
import { getContextCallCenter } from "app/pages/Booking/bookingSelectors";

const mapStateFromProps = state => {
	const contextCallCenter = getContextCallCenter({})(state);
	return {
		servicesPhone: contextCallCenter.services,
		helpContactUrl: contextCallCenter.helpContactUrl,
		preSalesPlanningUrl: state.callCenter.preSalesPlanningUrl,
		afterSalesPlanningUrl: state.callCenter.afterSalesPlanningUrl,
	};
};

const FaqContactContainer = props => {
	const stateProps = useSelector(mapStateFromProps, shallowEqual);
	return <FaqContact {...props} {...stateProps} />;
};

export default FaqContactContainer;
